import api from './axios';

// Get all gallery images
export const getAllImages = async (params = {}) => {
  const response = await api.get('/gallery', { params });
  return response.data;
};

// Get categories
export const getCategories = async () => {
  const response = await api.get('/gallery/categories');
  return response.data;
};

// Get single image
export const getImageById = async (id) => {
  const response = await api.get(`/gallery/${id}`);
  return response.data;
};

// Upload single image
export const uploadImage = async (formData) => {
  const response = await api.post('/gallery', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Bulk upload
export const bulkUpload = async (formData) => {
  const response = await api.post('/gallery/bulk', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update image
export const updateImage = async (id, data) => {
  // Check if data is FormData (for multipart updates with new image)
  const config = data instanceof FormData ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  
  const response = await api.patch(`/gallery/${id}`, data, config);
  return response.data;
};

// Delete image
export const deleteImage = async (id) => {
  const response = await api.delete(`/gallery/${id}`);
  return response.data;
};

// Bulk delete
export const bulkDelete = async (ids) => {
  const response = await api.delete('/gallery/bulk', { data: { ids } });
  return response.data;
};

const galleryService = {
  getAllImages,
  getCategories,
  getImageById,
  uploadImage,
  bulkUpload,
  updateImage,
  deleteImage,
  bulkDelete,
};

export default galleryService;
